var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgCard1SingleMetric(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 106.102,
    height: 57.435,
    viewBox: "0 0 106.102 57.435",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Union_82",
    "data-name": "Union 82",
    d: "M10.589,55.9a11.358,11.358,0,0,1-7.511-3.717A13.561,13.561,0,0,1,0,43.416V33.454H5.654V9.05h8.73V20.841H18.1v-5.76h7.6V0h6.655V15.082H43.329V25.47H38.578v7.984h66.2L93.022,55.9l-.642.011c-20.744.351-39.694.526-54.194.526C23.564,56.435,13.465,56.257,10.589,55.9ZM2.162,43.416a11.394,11.394,0,0,0,2.568,7.373,9.319,9.319,0,0,0,6.124,2.968c4.819.593,34.127.784,80.849,0l9.5-18.143H2.162ZM7.817,33.182h28.6V23.309h4.751V17.244H30.194V2.162H27.863V17.244h-7.6V23H12.221V11.213h-4.4ZM81.98,31v-9.14H96.423V31Zm2.162-2.163H94.26V24.019H84.141ZM65.405,31v-9.14H79.848V31Zm2.162-2.163H77.685V24.019H67.567ZM48.83,31v-9.14H63.272V31Zm2.162-2.163H61.11V24.019H50.991ZM81.98,19.572v-9.14H96.423v9.14Zm2.162-2.162H94.26V12.592H84.141ZM65.405,19.572v-9.14H79.848v9.14Zm2.162-2.162H77.685V12.592H67.567ZM48.83,19.572v-9.14H63.272v9.14Zm2.162-2.162H61.11V12.592H50.991Z",
    transform: "translate(0.5 0.5)",
    fill: "#7dd19d",
    stroke: "rgba(0,0,0,0)",
    strokeMiterlimit: 10,
    strokeWidth: 1
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCard1SingleMetric);
export default __webpack_public_path__ + "static/media/card-1-single-metric.a9badc080bfb1295ef682ab99844e7be.svg";
export { ForwardRef as ReactComponent };